import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const addIncidentParticipantMutation = loader(
  './addIncidentParticipant.graphql',
);

export const useIncidentMutations = () => {
  const [addIncidentParticipant] = useMutation(addIncidentParticipantMutation);

  const addParticipant = async ({
    userId,
    incidentId,
    onComplete = () => {},
  }) => {
    await addIncidentParticipant({
      variables: { incidentId, userId },
    }).then(() => onComplete());
  };

  return { addParticipant };
};
